/* Template: Groups
 ========================================================================== */

template.group_submit = function() {
	if ($('#gform_wrapper_6').length) {
		$('#gform_wrapper_6 form').submit(function(e) {
			bootbox.dialog({
				show: true,
				closeButton: false,
				message: '<div class="text-center"><img class="gform_ajax_spinner" src="/wp-content/plugins/gravityforms/images/spinner.gif" alt="">&nbsp;&nbsp;Submitting and validatating your group details, please bear with us...</div>'
			});
		});

		$('.content').on('DOMSubtreeModified propertychange', function() {
			bootbox.hideAll();
		});
	}
};

template.group_page = function() {
	$('.btn-scroll').click(function(event) {
		event.preventDefault();
		var targetOffset = $(this.hash).offset() ? $(this.hash).offset().top : 0;
		$('html, body').animate({
			scrollTop: targetOffset
		}, 350);
	});

	$('.btn-connect').click(function(e) {
		e.preventDefault();

		$(this).attr('disabled', 'disabled').text('Connecting...');

		var data = {
			'action': 'group_user_connect'
		};

		$.post(ajax_object.ajax_url, data, function(response) {
			location.reload();
		});
	});
};

template.groups_filter = function() {

	if (navigator.geolocation) {
		$('.geolocation-link-support').addClass('visible');
		$('.getlocation').addClass('visible');
		$('.geolocation-link').on('click', function() {
			var geocoder = new google.maps.Geocoder();
			$(this).children('.getlocation').removeClass('visible');
			$(this).children('.loading').addClass('visible');
			var _this = $(this);
			navigator.geolocation.getCurrentPosition(function(pos) {
				$("input[name='geolocation']").val(pos.coords.latitude + ', ' + pos.coords.longitude);
				var latlng = { lat: parseFloat(pos.coords.latitude), lng: parseFloat(pos.coords.longitude) };
				geocoder.geocode({
					'location': latlng
				}, function(results, status) {
					if (status === google.maps.GeocoderStatus.OK) {
						$("input[name='location']").val(results[0].formatted_address);
						$("input[name='location']").removeClass('error');
						_this.submit();
					} else {
						$("input[name='location']").addClass('error');
					}
				});
				_this.children('.loading').removeClass('visible');
				_this.children('.getlocation').addClass('visible');
			});
		});
	}

	$('#group-search').on('submit', function(event) {
		var geocoder = new google.maps.Geocoder();
		var location = $("input[name='location']").val();
		var mode = $("select[name='filtermode']").find(":selected").val();


		if (mode !== 'online') {

			if (location != '' || location != null) {
				event.preventDefault();
				var _this = this;

				geocoder.geocode({
					'address': location
				}, function(results, status) {
					if (status === google.maps.GeocoderStatus.OK) {
						var pos = results[0].geometry.location;
						var lat = pos.lat();
						var long = pos.lng();
						$("input[name='geolocation']").val(lat + ', ' + long);
						$("input[name='location']").removeClass('error');
						_this.submit();
					} else {
						$("input[name='location']").addClass('error');
					}
				});
			}
		} else {
			event.preventDefault();
			var selectedGroup = encodeURI($("select[name='digitalgroups']").find(":selected").val());
			window.location.href = selectedGroup;
		}
	});
};
